import styled from 'styled-components';

export const Span = styled.span`
  ${({ theme }) => theme.new.typography.p6};
  color: ${({ theme }) => theme.new.colors.brand};
`;
